import { Avatar } from "@chakra-ui/avatar";
import {
  Box,
  Flex,
  Text,
  Divider,
  Button,
  useToast,
  Image,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import TopSlider from "../Home/TopSlider";
import { useDispatch, useSelector } from "react-redux";
import {
  BASE_URL_MEDIA,
  BASE_URL_USER,
  getInterest,
} from "../../Redux/App/action";
import DeleteAddress from "./DeleteAddress";
import EditAddress from "./EditAddress";
import { FaXmark, FaPencil } from "react-icons/fa6";
import { GrFormEdit } from "react-icons/gr";
import CustomButton from "../customButton/CustomButton";

const MyProfile = () => {
  const accessToken = localStorage.getItem("token");
  const [profileData, setProfileData] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const [sourceMediaId, setSourceMediaId] = useState(0);
  const [imageData, setImageData] = useState("");
  const navigate = useNavigate();
  const [address, setAddress] = useState([]);
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const { interest } = useSelector((store) => store.appReducer);
  const toast = useToast();
  const [userinterest, setInterest] = useState([]);

  useEffect(() => {
    dispatch(getInterest);
  }, [dispatch]);

  const getProfileData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_USER}/api/v1/user/get-profile`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setProfileData(response.data.payload);
        setSourceMediaId(response.data.payload.userImg);
      }
    } catch (error) {
      console.clear(error);
    }
  };
  const getProfileImage = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_MEDIA}/media/file/admin/get/base64?sourceMediaId=${sourceMediaId}&dimension=ORIGINAL`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setImageData(response.data);
      }
    } catch (error) {
      console.clear(error);
    }
  };
  const getAddressData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_USER}/api/v1/user/get-address`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setAddress(response.data.payload);
      }
    } catch (error) {
      console.clear(error);
    }
  };

  const getIntrestList = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_MEDIA}/config/subcategories/bycategoryid?categoryId=17`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setInterest(response.data);
      }
    } catch (error) {
      console.clear(error);
    }
  };

  const handleDeleteAddress = async (addressId) => {
    try {
      const response = await axios.delete(
        `${BASE_URL_USER}/public-api/v1/user/delete-address?addressId=${addressId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        toast({
          title: "Address Deleted Successfully",
          status: "success",
          duration: 2000,
          position: "top",
          isClosable: true,
        });

        getAddressData();
      }
    } catch (error) {
      toast({
        title: error.message,
        status: "error",
        duration: 2000,
        position: "top",
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getProfileData();
    getProfileImage();
    getAddressData();
    getIntrestList();
  }, [sourceMediaId]);

  const handleLogout = () => {
    localStorage.clear();
    toast({
      title: "Logout Success",
      status: "success",
      duration: 5000,
      position: "top",
      isClosable: true,
    });
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      <Box textAlign={"left"} mb={14} mt={20}>
        <Box>
          <TopSlider />
        </Box>
        <Flex
          w={{ md: "95%", base: "98%" }}
          m={"auto"}
          mt={10}
          flexDirection={{ md: "row", base: "column-reverse" }}
        >
          <Flex
            w={{ md: "70%", base: "98%" }}
            gap={5}
            flexDirection={{ md: "row", base: "column" }}
            textAlign={{ md: "left", base: "center" }}
          >
            <Box
              w={{ md: "50%", base: "100%" }}
              mt={{ base: 5, md: 0 }}
              p={{ md: 0, base: 1 }}
            >
              <Box>
                <Flex
                  alignItems={"center"}
                  textAlign={{ md: "left", base: "left" }}
                  justifyContent={{ base: "space-between" }}
                >
                  <Text
                    w={{ md: "50%", base: "100%" }}
                    fontWeight={"semibold"}
                    fontSize={16}
                  >
                    <Flex alignItems={"center"} gap={1}>
                      <Text>Mobile Number</Text>
                    </Flex>
                  </Text>
                  <Text fontSize={14}>{profileData.mobileNumber}</Text>
                </Flex>
                <Flex
                  alignItems={"center"}
                  textAlign={{ md: "left", base: "left" }}
                  mt={2}
                  justifyContent={{ base: "space-between" }}
                >
                  <Text w={{ md: "50%" }} fontWeight={"semibold"} fontSize={16}>
                    <Flex alignItems={"center"} gap={1}>
                      Email
                    </Flex>
                  </Text>
                  <Text fontSize={14}>{profileData.email}</Text>
                </Flex>
                <Flex
                  alignItems={"center"}
                  textAlign={{ md: "left", base: "left" }}
                  mt={2}
                  justifyContent={{ base: "space-between" }}
                >
                  <Text w={{ md: "50%" }} fontWeight={"semibold"} fontSize={16}>
                    <Flex alignItems={"center"} gap={1}>
                      Date of Birth
                    </Flex>
                  </Text>
                  <Text fontSize={14}>{profileData.dob}</Text>
                </Flex>
                <Text
                  fontWeight={"bold"}
                  fontSize={16}
                  mt={10}
                  textAlign={{ md: "left", base: "center" }}
                >
                  <Flex
                    alignItems={"center"}
                    gap={1}
                    justifyContent={{ base: "center" }}
                  >
                    My Interest
                    <FaPencil
                      size={15}
                      onClick={() => {
                        onOpen();
                      }}
                      className="cursor-pointer"
                    />
                  </Flex>
                </Text>
                <Modal
                  initialFocusRef={initialRef}
                  finalFocusRef={finalRef}
                  isOpen={isOpen}
                  onClose={onClose}
                >
                  <ModalOverlay />
                  <ModalContent
                    borderRadius={0}
                    w={{ md: "30%", base: "90%" }}
                    textAlign={"left"}
                  >
                    <ModalHeader>
                      <Flex
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        Select Interest{" "}
                        <FaXmark onClick={onClose} className="cursor-pointer" />
                      </Flex>
                    </ModalHeader>
                    <ModalBody pb={6} borderRadius={0}>
                      <Box
                        display={"grid"}
                        gap={2}
                        gridTemplateColumns={"repeat(2,1fr)"}
                      >
                        {userinterest &&
                          userinterest.map((el, i) => (
                            <Button
                              colorScheme="red"
                              borderRadius={20}
                              h={8}
                              key={interest}
                              disabled={interest.map((ele, index) =>
                                ele.intersetName.includes(interest)
                              )}
                            >
                              {el.displayName}
                            </Button>
                          ))}
                      </Box>
                      <Flex mt={2}>
                        <Button colorScheme="blue" m={"auto"} w={"50%"}>
                          Save
                        </Button>
                      </Flex>
                    </ModalBody>
                  </ModalContent>
                </Modal>

                <Box
                  display={"grid"}
                  gridTemplateColumns={{
                    base: "repeat(2,1fr)",
                    md: "repeat(2, 3fr)",
                  }}
                  gap={2}
                  mt={4}
                >
                  {interest &&
                    interest.map((el, i) => (
                      <Button
                        borderRadius={10}
                        fontWeight={"semibold"}
                        fontSize={14}
                        color={"white"}
                        bgGradient="linear(to-r, #FE1745,#FC1B68)"
                        _hover={{
                          bgGradient: "linear(to-r, #FE1745,#FC1B68)",
                        }}
                        key={i}
                      >
                        {el.intersetName}
                      </Button>
                    ))}
                </Box>
              </Box>
            </Box>
            <Box w={{ md: "40%", base: "100%" }}>
              <Text color={"#3C375F"} fontSize={18} fontWeight={"bold"}>
                Your Addresses
              </Text>
              <Box
                mt={3}
                overflowY={"auto"}
                display={"grid"}
                gridTemplateColumns={"repeat(1,1fr)"}
                gap={5}
                px={2}
                py={2}
              >
                {address &&
                  address.map((address, i) => {
                    return (
                      <Box
                        key={i}
                        p={4}
                        borderRadius={10}
                        boxShadow={
                          "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;"
                        }
                      >
                        <div className="flex gap-2 justify-end items-center">
                          <DeleteAddress
                            addressId={address.id}
                            handleDeleteAddress={handleDeleteAddress}
                          />
                          <EditAddress
                            addressId={address.id}
                            getAddressData={getAddressData}
                          />
                        </div>
                        {address.default ? (
                          <>
                            <Text fontWeight={"semibold"} fontSize={15}>
                              Default:{" "}
                              <span
                                style={{ color: "#FE1648", fontWeight: "bold" }}
                              >
                                Wishfy
                              </span>
                            </Text>
                            <Divider border={"1px solid gray"} w={"90%"} />
                          </>
                        ) : null}
                        <Text fontSize={15} fontWeight={"bold"}>
                          {address.contactPersonName}
                        </Text>
                        <Text fontSize={12}>
                          {address.addressUnit}, {address.landmark},
                          <br />
                          {address.city}, {address.state}
                        </Text>
                        <Text fontSize={12}>{address.contactNo}</Text>
                      </Box>
                    );
                  })}
              </Box>
            </Box>
          </Flex>

          <Box w={{ md: "30%" }} boxShadow="md" borderRadius={10}>
            <Link to={"/updateProfile"} className="flex justify-end p-4">
              <FaPencil size={20} />
            </Link>
            <Flex
              w={"80%"}
              m={"auto"}
              justifyContent={"center"}
              alignItems={"center"}
              flexDirection={"column"}
              gap={10}
              py={10}
            >
              <Avatar
                size={"xl"}
                name={profileData.fullName}
                src={`data:image/png;base64,${imageData}`}
              />
              <Text fontWeight={"bold"} fontSize={16}>
                Hello, {profileData.fullName}
              </Text>

              <CustomButton
                onClick={() => {
                  handleLogout();
                }}
                className="!px-10 !bg-[#FC1A62]"
              >
                Logout
              </CustomButton>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default MyProfile;
